import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { AvatarWithActionButtonProps } from '../src/components/AvatarWithActionButton.tsx';

/**
 * Code-split wrapper for AvatarWithActionButton — the agent-session status row (avatar + status
 * badge/button).
 *
 * Used by the footer and comments-panel surfaces, which derive the session state inline and
 * render this only when a session exists and the cc_ai_agent_mention_from_comment experiment is
 * on. Keeping it in its own chunk avoids shipping its heavy deps (@atlaskit/avatar,
 * @atlaskit/button, @atlaskit/icon, AgentAvatar) in the initial view-page bundle for everyone.
 *
 * The callers already gate the render on `agentSessionState && expValEquals(...)`, so the chunk
 * loads only on that path.
 */
export const AvatarWithActionButtonAsync: LoadableType<AvatarWithActionButtonProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AvatarWithActionButton" */ '../src/components/AvatarWithActionButton.tsx'
			)
		).AvatarWithActionButton,
});
